export const ANNOTATION_GROUP_BUTTON_ID_PREFIX = `annotation-group-button`;
export const ANNOTATION_PLOT_LINE_ID = `annotation-plot-line`;
export const CREATE_ANNOTATION_ID = `create-annotation-id`;
export const EXISTING_ANNOTATIONS_BUTTON_Y = -4;
export const HOVER_PLOT_LINE_ID = `hover-plot-line`;
export const OPTIONAL_PLOT_LINE_ID = `optional-plot-line`;
